import React, {useState, useEffect} from 'react'
import {weapons} from '../data'
import prev from '../assets/prev.png'
import next from '../assets/next.png'



const Weapons = () => {
  // const [loading, setLoading] = useState(true)
  const [weaponData] = useState(weapons)
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const lastIndex = weaponData.length - 1;
    if(index < 0){
      setIndex(lastIndex)
    }
    if(index > lastIndex){
      setIndex(0)
    }
  }, [index, weaponData])


  useEffect(() => {
    let slider = setInterval(() => {
      setIndex(index + 1)
    }, 10000)
    return () => clearInterval(slider) 
  })

  const prevSilde = (index) => {
    setIndex(() => {
      let newIndex = index - 1
      if(newIndex < 0){
        newIndex = weaponData.length - 1
      }
      return newIndex
    });
  }

  const nextSlide = (index) => {
    setIndex(() => {
      let newIndex = index + 1
      if(newIndex > weaponData.length - 1){
        newIndex = 0
      }
      return newIndex
    });
  }

  const currentSlideTracker = (index) => {
    setIndex(index);
  }

  return (
    <section className='weapons scroll h-[700px] md:h-[800px] lg:h-[900px]' id='features'>
    {weaponData.map((weapon, weaponIndex) => {
      const {id, title, image, desc} = weapon 
      let position ='nextSlide'
      if(weaponIndex === index){
        position = 'activeSlide'
      }
      if(weaponIndex === index - 1 || (index === 0 && weaponIndex === weaponData.length - 1)){
        position = 'lastSlide'
      }
      return (  
        <div className = {`${position} weapons-grid flex flex-col items-center content-center px-[50px] pb-[100px] sm:pb-[150px]`} key={id} >
            <div className='weapons-text w-full md:w-full lg:w-[70%]'>
              <h1 className='font-face-tk weapons-title text-left sm:text-left text-xl sm:text-xl md:text-3xl lg:text-3xl' style={{width: '100%', color: 'rgb(246, 140, 31)', fontWeight: 'bold', textTransform: 'uppercase', marginBottom:'50px'}}>{title}</h1>
              <p className='weapons-paragraph hidden lg:block md:text-lg lg:text-xl order-last' style={{}}>{desc}</p>
            </div>
              <p className='weapons-paragraph text-sm pt-5 sm:pt-5 sm:text-base md:text-lg lg:text-xl order-last lg:hidden' style={{}}>{desc}</p>

              <div className='weapons-img h-[100px] sm:h-[200px]'>
                  <img src={image} alt='weapons' className='h-auto floating-gun'/>
              </div>
              
            </div>
      )
    })
  }
          <div className='carousel-controls flex justify-center w-[40%] h-[33px] sm:h-[33px] min-h-[33px] sm:min-h-[33px] lg:h-[44px] lg:min-h-[44px] absolute bottom-[100px] sm:bottom-[150px] ml-0 lg:bottom-[150px] sm:ml-[0] lg:ml-[67px] xl:ml-[97px]'>
            <button className='carousel-button carousel-previous mt-[0] sm:mt-[0] lg:mt-0 w-[33px] h-[33px] sm:w-[33px] sm:h-[33px] lg:w-[44px] lg:h-[44px]' onClick={() => prevSilde(index)}><img src= {prev} className='rounded-full' alt=''/></button>
              {weaponData.map((weapon, currentIndex) => (
                <React.Fragment>
                  <div className={`carousel-indicator cursor-pointer ${currentIndex === index ? 'carousel-indicator active' : 'carousel-indicator'}`} key={currentIndex} onClick={() => currentSlideTracker(currentIndex)}></div>
                </React.Fragment>
                ))}
            <button className='carousel-button carousel-next mt-[0] sm:mt-[0] lg:mt-0 w-[33px] h-[33px] sm:w-[33px] sm:h-[33px] lg:w-[44px] lg:h-[44px]' onClick={() => nextSlide(index)}><img src= {next}  className='rounded-full' alt=''/></button>
          </div>

    </section>
  )
}

export default Weapons